export default __webpack_public_path__ + "static/media/Chain of Unbreakable Links.7a6b6c52.jpg";